/**
 * 508 audit (2.1.1, 4.1.2). The index a roving-tabindex group moves to for a
 * key, or null when the key is not the group's.
 *
 * Shared by the WAI-ARIA tabs and radio group patterns: only the current item
 * is in the tab order, so these keys are the only way to the rest.
 *
 *  - Right and Down move to the next item, Left and Up to the previous,
 *    wrapping at either end.
 *  - Home and End move to the first and last.
 *  - A key held with Alt, Ctrl or Meta belongs to the browser or the system.
 */
export function rovingIndex(
  event: KeyboardEvent,
  from: number,
  count: number
): number | null {
  if (!count || event.altKey || event.ctrlKey || event.metaKey) {
    return null;
  }

  switch (event.key) {
    case 'ArrowRight':
    case 'ArrowDown':
      return (from + 1) % count;
    case 'ArrowLeft':
    case 'ArrowUp':
      return (from - 1 + count) % count;
    case 'Home':
      return 0;
    case 'End':
      return count - 1;
    default:
      return null;
  }
}

/**
 * Moves focus to item `index` of the group's `selector` items after Angular
 * has re-rendered the tabindex, which is why it waits a microtask.
 */
export function focusRovingItem(
  group: HTMLElement | null,
  selector: string,
  index: number
): void {
  Promise.resolve().then(() => {
    group?.querySelectorAll<HTMLElement>(selector)[index]?.focus();
  });
}
